import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Input, Button, Spin, notification } from 'antd';


import './index.scss';
import { updateDealSubmissionDetails } from '../../../../reducer/DealSubmission/actions';

export const DealEditorTab = ({ dealSubmission, isFetchingDealSubmission }) => {
  const dispatch = useDispatch();
  const [linkToPhotos, setLinkToPhotos] = useState(dealSubmission?.userData?.linkToPhotos || '');
  const [sellerName, setSellerName] = useState(dealSubmission?.userData?.sellerName || '');
  const [sellerPhoneNumber, setSellerPhoneNumber] = useState(dealSubmission?.userData?.sellerPhoneNumber || '');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (dealSubmission) {
      if (!dealSubmission.userData?.sellerName && dealSubmission.submittedBy?.name) {
        setSellerName(dealSubmission.submittedBy.name);
      }
      if (!dealSubmission.userData?.sellerPhoneNumber && dealSubmission.submittedBy?.phoneNumber?.number) {
        setSellerPhoneNumber(dealSubmission.submittedBy.phoneNumber.number);
      }
    }
  }, [dealSubmission]);

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await dispatch(updateDealSubmissionDetails(dealSubmission._id, {
        userData: {
          linkToPhotos,
          sellerName,
          sellerPhoneNumber,
        },
      }));
      notification.success({
        message: 'Success',
        description: 'Link to photos has been updated successfully.',
      });
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to update link to photos.',
      });
    } finally {
      setIsSaving(false);
    }
  };

  if (isFetchingDealSubmission) {
    return <Spin />;
  }

  return (
    <div className="deal-editor-tab">
      <div className="form-group">
        <label>Link to Photos</label>
        <Input
          value={linkToPhotos}
          onChange={(e) => setLinkToPhotos(e.target.value)}
          placeholder="Enter link to photos"
        />
      </div>
      <div className="form-group">
        <label>Seller Name</label>
        <Input
          value={sellerName}
          onChange={(e) => setSellerName(e.target.value)}
          placeholder="Enter seller name"
        />
      </div>
      <div className="form-group">
        <label>Seller Phone Number</label>
        <Input
          value={sellerPhoneNumber}
          onChange={(e) => setSellerPhoneNumber(e.target.value)}
          placeholder="Enter seller phone number"
        />
      </div>
      <Button
        type="primary"
        onClick={handleSave}
        loading={isSaving}
        disabled={!linkToPhotos && !sellerName && !sellerPhoneNumber}
      >
        Save
      </Button>
    </div>
  );
};
